/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Price_SubInputs */

const en_cp_price_sub = /** @type {(inputs: Cp_Price_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IDR 299k per team per semester is about IDR 12.5k per student per month. Class and campus prices are derived from the real AI cost per team, so volume discounts are small but kickoff, rubric, and lecturer training are included.`)
};

const id_cp_price_sub = /** @type {(inputs: Cp_Price_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rp 299 rb per tim per semester setara Rp 12,5 rb per mahasiswa per bulan. Harga kelas dan kampus dihitung dari biaya AI riil per tim, jadi diskon volume kecil tapi program kickoff, rubrik, dan pelatihan dosen sudah termasuk.`)
};

/**
* | output |
* | --- |
* | "IDR 299k per team per semester is about IDR 12.5k per student per month. Class and campus prices are derived from the real AI cost per team, so volume discou..." |
*
* @param {Cp_Price_SubInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_price_sub = /** @type {((inputs?: Cp_Price_SubInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Price_SubInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_price_sub(inputs)
	return en_cp_price_sub(inputs)
});